import { useEffect, useState } from "react";
import { Download, Package } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate, download } from "../../lib/api";
import { Button } from "../ui/button";
import { NoManuscript } from "./NoManuscript";

export default function ExportsTab({ book, version }) {
  const [hist, setHist] = useState([]);
  const [uploads, setUploads] = useState([]);
  const load = () => { api.get(`/books/${book.id}/exports`).then((r) => setHist(r.data)); api.get(`/books/${book.id}/uploads`).then((r) => setUploads(r.data)); };
  useEffect(load, [book.id]); // eslint-disable-line
  if (!version) return <NoManuscript />;
  const dl = (path, name) => download(path, name).then(load).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="grid lg:grid-cols-2 gap-6">
      <div className="panel p-6 space-y-3" data-testid="export-current">
        <p className="eyebrow mb-2">Current manuscript · v{version.number}</p>
        {[["docx", "Manuscript DOCX"], ["md", "Markdown (compile-ready)"], ["html", "Clean HTML (KDP / Google Play)"], ["txt", "Plain text"]].map(([f, l]) => (
          <Button key={f} variant="outline" className="w-full justify-start border-slate-700 whitespace-normal h-auto min-h-9 text-left" onClick={() => dl(`/books/${book.id}/versions/${version.id}/export?fmt=${f}`, `manuscript.${f}`)} data-testid={`export-${f}-button`}><Download size={14} className="mr-2" />{l}</Button>
        ))}
        <Button className="w-full justify-start bg-amber-600 hover:bg-amber-500" onClick={() => dl(`/books/${book.id}/package`, "package.zip")} data-testid="export-package-button"><Package size={14} className="mr-2" />ZIP package (originals + {book.approved_version_id ? "approved" : "current"} manuscript)</Button>
        <p className="text-xs text-slate-500 pt-2">Validated EPUB downloads live in the Ebook tab. Print-ready PDFs, cover wraps and formatted DOCX live in the Paperback and Hardcover tabs; audiobook packages in the Audiobook tab.</p>
      </div>
      <div className="panel p-6" data-testid="export-originals">
        <p className="eyebrow mb-4">Original uploads</p>
        {uploads.map((u) => <button key={u.id} className="w-full flex justify-between text-sm py-2 text-slate-300 hover:text-amber-300" onClick={() => dl(`/uploads/${u.id}/download`, u.filename)} data-testid={`export-original-${u.id}`}><span className="truncate">{u.filename}</span><Download size={14} /></button>)}
        {!uploads.length && <p className="text-sm text-slate-500">None</p>}
      </div>
      <div className="panel p-6 lg:col-span-2" data-testid="export-history">
        <p className="eyebrow mb-4">Export history</p>
        {hist.length === 0 && <p className="text-sm text-slate-500">No exports yet.</p>}
        {hist.map((h) => <div key={h.id} className="flex justify-between text-sm py-1.5 border-b border-slate-800/60"><span className="font-mono text-xs text-slate-300">{h.filename}</span><span className="text-xs text-slate-500">{fmtDate(h.created_at)}</span></div>)}
      </div>
    </div>
  );
}
